import clsx from "clsx"
import type { PropsWithChildren } from "react"

export const Badge = ({ exist, children }: PropsWithChildren & { exist?: boolean }) => {
  return (
    <div className="relative">
      <div className={clsx("notification-badge", `notification-badge__${exist ? "exist" : "not-exist"}`)} />
      {children}
    </div>
  )
}
